import React, { useState, useEffect } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import PostbackPageComponent from '../PostbackPage/PostbackPage.container';
import CheckContent from '../../../CheckContent';

const EditPostbackPage = ({ 
    loading, 
    params, 
    postback, 
    getListPostbacks, 
    saveSuccess,
    t 
}) => {
    const [state, setState] = useState({
        loading: loading || false,
        id: params?.id || null,
        postback: postback || {}
    });

    useEffect(() => {
        const id = params?.id;
        if (getListPostbacks && id) {
            getListPostbacks(id);
        }
    }, [params?.id, getListPostbacks]);

    useEffect(() => {
        if (params?.id && params.id !== state.id) {
            setState(prevState => ({
                ...prevState,
                id: params.id
            }));
        }
    }, [params?.id, state.id]);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            loading: loading,
            postback: postback || {}
        }));
    }, [loading, postback]);


    const staticNames = t?.postbackPage?.editing || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <CheckContent
                    loading={state.loading || loading}
                    isEmpty={false}
                >
                    <div className="ibox postback edit-postback">
                        <PostbackPageComponent
                            postback={postback || state.postback}
                            params={params}
                        />
                    </div>
                </CheckContent>
            </section>
        </React.Fragment>
    );
};

EditPostbackPage.propTypes = {
    loading: PropTypes.bool,
    params: PropTypes.object,
    postback: PropTypes.object,
    getListPostbacks: PropTypes.func,
    t: PropTypes.object
};

EditPostbackPage.defaultProps = {
    loading: false,
    params: {},
    postback: {},
    getListPostbacks: () => {},
    t: {}
};

export default withTranslation(EditPostbackPage);